import Main from "./Componets/Main";
import BackgroundApp from "./Componets/Background_app";
import AcercaDeMi from "./Componets/Acerca_de_mi";
import Resumen from "./Componets/Resumen";
import Skill from "./Componets/Skill";
import Content from "./Componets/Content";
import Portafolio from "./Componets/Portafolio";
import Reveal from "./Componets/Reveal";
import Preloader from "./Componets/Preloader";
import ScrollDebug from "./Componets/ScrollDebug";
import { LoadingProvider, useLoadingContext } from "./context/LoadingContext";

import "./App.css";

import React, { useEffect } from "react";
import ReactGA from "react-ga4";

// Evita que el navegador restaure el scroll al recargar
if ("scrollRestoration" in window.history) {
  window.history.scrollRestoration = "manual";
}

const TRACKING_ID = "UA-137266075-1";
ReactGA.initialize(TRACKING_ID);

function AppContent() {
  const { allReady, preloaderDone, setPreloaderDone } = useLoadingContext();

  useEffect(() => {
    window.scrollTo(0, 0);
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname + window.location.search,
    });
  }, []);

  return (
    <>
      {/* Preloader encima — desaparece cuando allReady + animación termina */}
      {!preloaderDone && (
        <Preloader
          onComplete={allReady ? () => setPreloaderDone(true) : undefined}
        />
      )}

      <ScrollDebug />

      {/* Contenido siempre montado debajo del preloader */}
      <div>
        <Main />
        <Content>
          <Reveal triggerAt={0} delay={1.2}>
            <AcercaDeMi />
          </Reveal>
          <Reveal triggerAt={100}>
            <Skill />
          </Reveal>
          <Reveal triggerAt={720}>
            <Resumen />
          </Reveal>
          <Reveal triggerAt={1455}>
            <Portafolio />
          </Reveal>
        </Content>
        <BackgroundApp />
      </div>
    </>
  );
}

function App() {
  return (
    <LoadingProvider>
      <AppContent />
    </LoadingProvider>
  );
}

export default App;
